import {
  collection,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { HistoryEntryName } from '@leedpulse-monorepo/enums';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';

/**
 * Date of the last user history entry with the given name, or null when there is none.
 * Sorted here: a `where` next to an `orderBy` would need a composite index, and a user only has a handful of entries.
 */
export async function getLastUserHistoryDate(
  userUid: string,
  name: HistoryEntryName
): Promise<number | null> {
  const historyCollection = collection(
    firestore,
    FirestoreCollections.users,
    userUid,
    FirestoreCollections.users_history
  );
  const results = await getDocs(query(historyCollection, where('name', '==', name)));
  const aTimestamps = results.docs.map((doc) => doc.data().timestamp as number);
  return aTimestamps.length ? Math.max(...aTimestamps) : null;
}

export class GetLastUserHistoryDateFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getLastUserHistoryDate;
